export const SET_PROFILE_FIELD = 'SET_PROFILE_FIELD';

export function setProfileField(key, value) {
    return { type: SET_PROFILE_FIELD, key, value };
}
